module.exports = __webpack_public_path__ + "static/img/streamMedia-right.03212ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-right.png
// module id = 345
// module chunks = 1